import axios from '../../axiosConfig/metaaxios'
export const getHeaderdata = {
    getBanner: async (callback) => {
        axios.get('/header',
            {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        )
            .then((data) => {
                callback(null, data)
            }).catch(err => {
                callback(err, null)
            })
    }
}